module.exports = __webpack_public_path__ + "img/mascota.7a326c78.png";